import React, { useState } from 'react';
import PageHeader from '../Components/common/PageHeader';
import CommunicationCard from '../Components/ContactElements/CommunicationCard';
import Banner from '../Containers/Banner';
import emailjs from '@emailjs/browser';
import { EMAIL_CONFIG } from '../utils/emailConfig';

const ContactPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const [status, setStatus] = useState({
        submitted: false,
        success: false,
        message: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setStatus({ submitted: true, success: false, message: 'Invio in corso...' });

        const templateParams = {
            from_name: formData.name,
            reply_to: formData.email,
            to_name: "RB Costruzioni",
            message: formData.message,
            phone: formData.phone,
            subject: formData.subject
        };

        emailjs.send(
            EMAIL_CONFIG.SERVICE_ID,
            EMAIL_CONFIG.TEMPLATE_ID,
            templateParams,
            EMAIL_CONFIG.PUBLIC_KEY
        )
        .then((response) => {
            console.log('SUCCESS!', response.status, response.text);
            setStatus({
                submitted: false,
                success: true,
                message: 'Grazie! Il tuo messaggio è stato inviato con successo.'
            });
            setFormData({
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: ''
            });
        })
        .catch((err) => {
            console.error('FAILED...', err);
            setStatus({
                submitted: false,
                success: false,
                message: 'Si è verificato un errore. Riprova più tardi.'
            });
        });
    };

    const ContactData = [
        {
            id: '1',
            iconClass: 'ion-ios-telephone-outline',
            infoBody01: 'Telefono',
            infoBody02: '+340 5327626',
        },
        {
            id: '2',
            iconClass: 'fa fa-envelope-o',
            infoBody01: 'Email',
            infoBody02: 'preventivirb@gmail.com',
            //infoBody03: 'care@builderrine.com',
        },
        {
            id: '3',
            iconClass: 'fa fa-map-marker',
            infoBody01: 'Indirizzo',
            infoBody02: 'Via Tagliamento 24 Mirandola (MO)',
            infoBodyClass: 'd-none',
        },
    ];

    return (
        <>
            <PageHeader activeClass01='active' activeClass02='d-none' routeName01='Contattaci' heading='Contattaci' />

            <div className="main_wrapper">
                <div className="contact_inner">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-5">
                                <div className="keepintouch_3">
                                    {
                                        ContactData.map(data => <CommunicationCard
                                            key={data.id}
                                            data={data}
                                        />)
                                    }
                                </div>
                            </div>
                            <div className="col-lg-7 col-md-7 offset-lg-1">
                                <div className="contact_us_1">
                                    <div className="section_header">
                                        <h6 className="section_sub_title">Contattaci</h6>
                                        <h1 className="section_title">Vuoi avere informazioni riguardo i nostri servizi?<br />
                                           Non esitare a contattarci</h1>
                                    </div>
                                    <form className="contact_form" onSubmit={handleSubmit}>
                                        <div className="form-container">
                                            <div className="row">
                                                <div className="col-md-6 col-lg-6">
                                                    <div className="form-group">
                                                        <input 
                                                            type="text" 
                                                            name="name" 
                                                            className="form-control" 
                                                            placeholder="Il tuo Nome*" 
                                                            required 
                                                            value={formData.name}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <div className="form-group">
                                                        <input 
                                                            type="email" 
                                                            name="email" 
                                                            className="form-control" 
                                                            placeholder="Indirizzo Email*" 
                                                            required 
                                                            value={formData.email}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <div className="form-group">
                                                        <input 
                                                            type="text" 
                                                            name="phone" 
                                                            className="form-control" 
                                                            placeholder="Numero di Telefono" 
                                                            value={formData.phone}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <div className="form-group">
                                                        <input 
                                                            type="text" 
                                                            name="subject" 
                                                            className="form-control" 
                                                            placeholder="Oggetto" 
                                                            value={formData.subject}
                                                            onChange={handleChange}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-lg-12">
                                                    <div className="form-group">
                                                        <textarea 
                                                            name="message" 
                                                            className="form-control" 
                                                            placeholder="Il tuo Messaggio*" 
                                                            required
                                                            value={formData.message}
                                                            onChange={handleChange}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 col-lg-12">
                                                    {status.message && (
                                                        <div className={`alert alert-sm ${status.success ? 'alert-success' : 'alert-info'}`} style={{fontSize: '0.9rem', padding: '0.5rem'}}>
                                                            {status.message}
                                                        </div>
                                                    )}
                                                    <div className="form-group">
                                                        <button 
                                                            className="button btn-sm" 
                                                            type="submit"
                                                            style={{
                                                                fontSize: '0.9rem',
                                                                padding: '0.5rem 1rem',
                                                                minWidth: '120px'
                                                            }}
                                                            disabled={status.submitted}
                                                        >
                                                            {status.submitted ? 'Invio...' : 'Invia'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Banner
                    title='La tua casa è sicura? Chiama noi per installare dispositivi di sicurezza'
                    heading='Chiama noi in qualsiasi momento'
                    phone='340 5327626'
                    bannerType='banner banner_bg_color'
                />
            </div>

        </>
    );
};

export default ContactPage;